<template>
  <div>
    <v-dialog v-model="show">
      <v-card>
        <v-card-title>
          <h3>Reschedule History - {{ delivery.name }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="show=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
<!--        <v-system-bar lights-out></v-system-bar>-->
        <h4 style="margin-left: 50px" v-if="timeHistory.length === 0">Reschedule History Record</h4>
        <v-carousel
          :continuous="false"
          :cycle="cycle"
          hide-delimiters
          v-model="model"
          height="400"
          :show-arrows="true"
        >
          <v-carousel-item
            v-for="(time, i) in timeHistory"
            :key="i"
          >
            <v-sheet
              color="white"
              height="100%"
              tile
            >
              <v-row
                class="fill-height"
                align="center"
                justify="center"
              >
                <v-container>
                  <v-row  v-show="model === (timeHistory.length - 1)" align="center" style="color:black; margin-left: 50%" >
                    <h3  >Current Window</h3>
                  </v-row>

                  <v-row  align="center" style="color:black" >
                    <h3 v-if="isInternalUser && time.client_name && time.username">{{time.client_name + '--'+ time.username + '--' + time.time}} From</h3>
                    <h3 v-else>From</h3>
                  </v-row>

                  <v-row justify="center">
                    <v-col cols="4" md="4" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">event_note</v-icon>
                        </v-list-item-action>

                        <v-list-item-content  style="color:black">
                          <v-list-item-subtitle style="color:black" >Date</v-list-item-subtitle>
                          {{ time.from_date}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="4" md="4" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">access_time</v-icon>
                        </v-list-item-action>
                        <v-list-item-content style="color:black" >
                          <v-list-item-subtitle style="color:black">Window start</v-list-item-subtitle>
                          {{time.from_window_start}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="4" md="4" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">access_time</v-icon>
                        </v-list-item-action>
                        <v-list-item-content  style="color:black">
                          <v-list-item-subtitle style="color:black">Window End</v-list-item-subtitle>
                          {{time.from_window_end}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>

                  <v-divider color="#42a5f5"></v-divider>
                  <br>
                  <v-row  align="center" style="color:black" >
                    <h3  >To</h3>
                  </v-row>

                  <v-row justify="center">
                    <v-col cols="4" md="4" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">event_note</v-icon>
                        </v-list-item-action>

                        <v-list-item-content  style="color:black">
                          <v-list-item-subtitle style="color:black" >Date</v-list-item-subtitle>
                          {{ time.to_date}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="4" md="4" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">access_time</v-icon>
                        </v-list-item-action>
                        <v-list-item-content style="color:black" >
                          <v-list-item-subtitle style="color:black">Window start</v-list-item-subtitle>
                          {{time.to_window_start}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="4" md="4" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">access_time</v-icon>
                        </v-list-item-action>
                        <v-list-item-content  style="color:black">
                          <v-list-item-subtitle style="color:black">Window End</v-list-item-subtitle>
                          {{time.to_window_end}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-card>
      <v-card>
        <v-card-actions class="justify-center">
              <v-btn text color="blue-grey lighten-2" @click="show=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "RescheduleHistoryDialog",
    props: {
      delivery: Object,
      showProp: Boolean
    },
    data() {
      return {
        availableSelectTimeWindows:[],
        cycle: false,
        timeHistory: [
        ],
        model:0,
      }
    },
    computed: {
      show: {
        get() {
          return this.showProp;
        },
        set(value) {
          if (!value) this.$emit('close');
        }
      },
      editPermission() {
        return this.$store.getters['auth/hasPermissionRegionId']('delivery_reschedule', this.delivery.region_id);
      },
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      renderedhistory() {
        if (this.history === null || this.history === undefined) {
          this.history = [];
          this.history.unshift({from_date:null,from_window_start:null,from_window_end:null,
                                      to_date:null,to_window_start:null,to_window_end:null,
                                       });
          return this.history;
        } else return this.history;
      },
    },
    asyncComputed: {
      async history() {
        if (this.delivery === null) return [];
        return await axios.get(process.env.API_URL + '/deliveries/' + this.delivery.tracking + '/reschedule')
            .then((response) => {
              this.timeHistory = response.data;
              this.model = this.timeHistory.length - 1;
              return response.data;
            })
            .catch((err) => {
              this.$store.commit('displaySnackbar', 'ERROR loading reschedule history');
              return [];
            });
      }
    },
    mounted() {
      this.history;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/RescheduleHistoryDialog.vue